// Shared status/type pill. Replaces two separate local implementations
// (InstructorDashboard's StatusBadge, Schools.tsx's TypeBadge) that drew the same
// shape with their own one-off color maps.

export type BadgeTone = 'success' | 'warning' | 'danger' | 'neutral'

const TONE: Record<BadgeTone, { bg: string; color: string }> = {
  success: { bg: 'rgba(15,124,108,0.1)',  color: '#0F7C6C' },
  warning: { bg: 'rgba(212,151,43,0.12)', color: '#9A6C0E' },
  danger:  { bg: 'var(--danger-10)',      color: 'var(--danger)' },
  neutral: { bg: 'rgba(27,42,74,0.07)',   color: 'var(--ink-60)' },
}

export function Badge({ label, tone = 'neutral' }: { label: string; tone?: BadgeTone }) {
  const s = TONE[tone]
  return (
    <span style={{
      padding: '3px 9px', borderRadius: 20, flexShrink: 0, whiteSpace: 'nowrap',
      background: s.bg, color: s.color,
      font: '600 11.5px Inter, sans-serif',
    }}>
      {label}
    </span>
  )
}

// A translucent white pill for use on a colored (e.g. teal LessonCard) background,
// where Badge's own tones all assume a light page background and lose contrast.
export function WhiteBadge({ label }: { label: string }) {
  return (
    <span style={{
      padding: '3px 9px', borderRadius: 20, flexShrink: 0, whiteSpace: 'nowrap',
      background: 'rgba(255,255,255,0.2)', color: '#fff',
      font: '600 11.5px Inter, sans-serif',
    }}>
      {label}
    </span>
  )
}
